import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=58da19cc&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeleteButton.vue"
export default component.exports